const homeContent = require("static/content/fr/home.json");
const productsContent = require("static/content/fr/products.json");
const resultsContent = require("static/content/fr/results.json");

export default {
  home: homeContent,
  products: productsContent,
  results: resultsContent,
};
